import { Box } from "@chakra-ui/react";
import Image from "next/image";
import { getCdnImageSrc } from "../utils";
import { colors } from "../styles";
import { Button } from "./Buttons";

interface ReviewCardProps {
  imageUrl: string;
  reviewText: string;
  reviewDate: string;
  onClickMore?: () => void;
  buttonText?: string;
  width?: string | number;
}

const ReviewPhotoCard = ({
  imageUrl,
  reviewText,
  reviewDate,
  onClickMore,
  buttonText = "관련 후기 보기",
  width = "100%",
}: ReviewCardProps) => {
  return (
    <Box
      css={{
        width: width,
        backgroundColor: "white",
        borderRadius: "12px",
        boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      {/* 이미지 */}
      <Box
        css={{
          width: "100%",
          height: "234px",
          position: "relative",
        }}
      >
        <Image src={getCdnImageSrc(imageUrl)} alt="후기 이미지" fill />
      </Box>

      {/* 텍스트 내용 */}
      <Box
        css={{
          padding: "16px 20px",
        }}
      >
        <Box
          className="body_14_r"
          css={{
            color: colors.gray700,
            marginBottom: "21px",
          }}
        >
          &ldquo;{reviewText}&rdquo; - {reviewDate} 후기
        </Box>

        {/* 관련 후기 보기 버튼 */}
        <Button
          className="body_16_r"
          css={{
            width: "100%",
            height: "40px",
            padding: "12px",
            borderRadius: "6px",
            backgroundColor: colors.gray50,
            border: "none",
            color: colors.gray700,
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={onClickMore}
        >
          {buttonText}
        </Button>
      </Box>
    </Box>
  );
};

export { ReviewPhotoCard };
